import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import { LogOut } from 'react-feather';
import { useHotkeys } from 'react-hotkeys-hook';
import AdminMultiSearch from './AdminMultiSearch';
import { apiHost } from '@pv/common/api';

const API_HOST = apiHost(process.env.REACT_APP_PV_ENV as string);

const version = process.env.REACT_APP_RELEASE_VERSION;
console.log('RELEASE_VERSION', version);

interface NavigationBarProps {
  authenticatedAdmin: {
    id: number;
    email: string;
  };
}

export default function NavigationBar({
  authenticatedAdmin,
}: NavigationBarProps) {
  const theme = useTheme();
  const [multiSearchOpen, setMultiSearchOpen] = useState(false);
  useHotkeys('meta+k', () => {
    setMultiSearchOpen(true);
  });
  useHotkeys('esc', () => {
    setMultiSearchOpen(false);
  });

  const onMultisearchClose = () => {
    setMultiSearchOpen(false);
  };

  return (
    <>
      <AppBar className="admin-app-bar" position="static">
        <Toolbar>
          <Typography variant="h4" style={{ color: 'white', flexShrink: 1 }}>
            PVAdmin
          </Typography>
          {version && (
            <Typography
              style={{
                marginLeft: theme.spacing(2),
                color: 'white',
                flexShrink: 1,
              }}
            >
              v.{version}
            </Typography>
          )}
          <div style={{ flexGrow: 1 }} />
          <Button
            href={`/admin`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Home
          </Button>
          <Button
            href="/admin/assistant-conversations"
            style={{ color: 'white' }}
          >
            Assistants
          </Button>
          <Button
            href={`/admin/organizations`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Organizations
          </Button>
          <Button
            href={`/admin/venues`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Venues
          </Button>
          <Button
            href={`/admin/users`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Users
          </Button>
          <Button
            onClick={() => setMultiSearchOpen(true)}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Search (Cmd+K)
          </Button>
          <Button
            href={`/admin/payments`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Payments
          </Button>
          <Button
            href={`/admin/fraud-scanner`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Fraud Scanner
          </Button>
          <Button
            href={`/admin/opentable-syncs`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            OpenTable
          </Button>
          <Button
            href={`${API_HOST}/admin/sidekiq`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            Sidekiq
          </Button>
          <Button
            href={`/admin/oauth-applications`}
            style={{ color: 'white', margin: theme.spacing(0, 2) }}
          >
            OAuth Apps
          </Button>
          <Box>
            <Typography
              style={{
                color: 'white',
                margin: theme.spacing(0, 2),
              }}
            >
              {authenticatedAdmin.email}
            </Typography>
          </Box>
          <IconButton
            className="admin-logout-button"
            data-cy="admin-logout-button"
            color="inherit"
            href={`${API_HOST}/admins/sign_out`}
          >
            <LogOut />
          </IconButton>
        </Toolbar>
      </AppBar>
      <AdminMultiSearch open={multiSearchOpen} onClose={onMultisearchClose} />
    </>
  );
}
